import enums from '../enums/RdsLife.enums';
export default class Notification {
  constructor({ id, topic, title, body, author }) {
    this.id = id;
    this.topic = topic;
    this.title = title;
    this.body = body;
    this.author = author;
    this.tipologia = enums.modelTypes.NOTIFICATION;
  }
}
